import React from 'react';
import {SimpleForm , Edit, TextInput , DateInput  , ReferenceInput, SelectInput , ImageInput , ImageField , 
    SaveButton , Toolbar , translate, ArrayField , SingleFieldList , number} from 'react-admin';
import Button from '@material-ui/core/Button';

const CsEditToolbar = translate(({ onCancel, translate, ...props }) => (
    <Toolbar {...props}>
        <SaveButton />
        <Button onClick={onCancel}>{translate('ra.action.cancel')}</Button>
    </Toolbar>
));
const validateDate = [number('YYYYMMDD 형식으로 숫자만 입력해 주세요')];

const CsEdit = ({ onCancel, ...props }) => (
    <Edit title="  " {...props}>
        <SimpleForm toolbar ={<CsEditToolbar onCancel={onCancel} />}>
            <TextInput validate={validateDate} source ='date' label="일자" />
            <ReferenceInput source ='customerId' label="고객사" perPage={500} reference="customers" >
                <SelectInput  optionText="name"/>
            </ReferenceInput>
            <ReferenceInput source ='csCategoryId' label="CS분류" reference="commonCodes" filter={{ type: '09' }}>
                <SelectInput  optionText="desc" />
            </ReferenceInput>
            {/* <SelectInput source ='csCategoryId' label="CS분류" choices={[
                    { id: '51', name: '배송' },
                    { id: '52', name: '음식' },
                    { id: '53', name: '위생' },
                    { id: '54', name: '기타' },
                ]}></SelectInput> */}
            
            <TextInput source ='desc' label="내용" resettable multiline />
            <ImageInput label="CS이미지" source="csFile" multiple={true} accept="image/*">
                <ImageField source="fullPath" />
            </ImageInput>
        </SimpleForm>
    </Edit>
);

export default CsEdit;